// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__3ZU62","disclaimer":"Summary_disclaimer__2kXUt"};